import { useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { Sparkles, CheckCircle2 } from "lucide-react";
import { toast } from "sonner";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [reason, setReason] = useState("");
  const [busy, setBusy] = useState(false);
  const [done, setDone] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await api.post("/auth/forgot-password", { email, phone, reason });
      setDone(true);
    } catch (err) {
      toast.error(err.response?.data?.detail || "Gönderilemedi");
    } finally { setBusy(false); }
  };

  return (
    <div className="cosmic-bg min-h-screen flex items-center justify-center px-4">
      <div className="stars" />
      <div className="w-full max-w-md fade-up">
        <Link to="/" className="flex items-center gap-2 justify-center mb-8">
          <Sparkles className="w-7 h-7 gold-text" />
          <span className="font-serif-myst text-3xl font-semibold">FalZilla</span>
        </Link>

        <div className="glass rounded-3xl p-8" data-testid="forgot-page">
          {done ? (
            <div className="text-center py-4" data-testid="forgot-success">
              <CheckCircle2 className="w-14 h-14 gold-text mx-auto mb-3" />
              <h1 className="font-serif-myst text-2xl mb-2">Talebiniz alındı</h1>
              <p className="text-white/60 text-sm mb-4">Yöneticimiz en kısa sürede size ulaşacak ve yeni şifrenizi iletecek. Genellikle 24 saat içinde yanıt veriyoruz.</p>
              <Link to="/giris" className="btn-gold inline-block px-6 py-2.5 rounded-full">Girişe Dön</Link>
            </div>
          ) : (
            <>
              <h1 className="font-serif-myst text-3xl mb-2 text-center">Şifremi Unuttum</h1>
              <p className="text-white/60 text-center text-sm mb-6">E-posta ve iletişim bilgini bırak, yönetici manuel olarak yeni şifreni oluşturup sana iletsin.</p>
              <form onSubmit={submit} className="space-y-4">
                <div>
                  <label className="text-xs text-white/60 mb-1 block">E-posta *</label>
                  <input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} data-testid="forgot-email" className="w-full bg-white/5 border border-white/10 rounded-xl px-4 py-3 text-white focus:outline-none focus:border-[#D4AF37]/50" placeholder="hesap@mail.com" />
                </div>
                <div>
                  <label className="text-xs text-white/60 mb-1 block">Telefon (opsiyonel)</label>
                  <input value={phone} onChange={(e) => setPhone(e.target.value)} data-testid="forgot-phone" className="w-full bg-white/5 border border-white/10 rounded-xl px-4 py-3 text-white focus:outline-none focus:border-[#D4AF37]/50" placeholder="+90..." />
                </div>
                <div>
                  <label className="text-xs text-white/60 mb-1 block">Not (opsiyonel)</label>
                  <textarea value={reason} onChange={(e) => setReason(e.target.value)} rows={3} data-testid="forgot-reason" className="w-full bg-white/5 border border-white/10 rounded-xl px-4 py-3 text-white focus:outline-none focus:border-[#D4AF37]/50" placeholder="Kayıtlı olduğun ismi ya da doğrulama için bir şey yazabilirsin" />
                </div>
                <button type="submit" disabled={busy} data-testid="forgot-submit" className="btn-gold w-full py-3 rounded-xl">{busy ? "Gönderiliyor..." : "Şifre Sıfırlama Talebi Gönder"}</button>
              </form>
              <div className="text-center text-sm text-white/60 mt-6">
                <Link to="/giris" data-testid="forgot-back-login" className="hover:gold-text">← Girişe dön</Link>
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
}
